export const PlusIcon = ({ className = '', expanded = false }) => {
  return (
    <svg
      className={className}
      width="9"
      height="8"
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.804688"
        y="3.55469"
        width="7.3875"
        height="0.73875"
        rx="0.369375"
        fill="#444444"
      />
      <rect
        x="4.86719"
        y="0.230469"
        width="7.3875"
        height="0.73875"
        rx="0.369375"
        transform="rotate(90 4.86719 0.230469)"
        className={`${
          expanded ? 'rotate-90' : ''
        } ease transition-transform duration-300`}
        fill="#444444"
      />
    </svg>
  )
}
